import classNames from "classnames";
import AppContext from "PFApp/app_context";
import { SearchInput } from "PFApp/components/search_input";
import { getValueFilters } from "PFApp/use_filtered_collection";
import PropTypes from "prop-types";
import React, { useContext } from "react";

import css from "./roles_header.module.scss";

const RolesHeader = ({ className }) => {
  const {
    store: {
      pages: {
        workflowPage: {
          roles: {
            data: { meta },
            updateFilter
          }
        }
      }
    }
  } = useContext(AppContext);

  const valueFilters = getValueFilters(meta.filters);
  delete valueFilters.fields?.state;

  const termFilter = meta.filters.fields?.term;
  const handleTermChange = (term) => updateFilter(termFilter, term);

  const termValue = termFilter?.value || "";

  return (
    <div className={classNames(css.container, className)}>
      <div className={css.scrollWrapper}>
        <SearchInput term={termValue} onTermChange={handleTermChange} qaId="WorkflowPageRolesSearch" />
      </div>
    </div>
  );
};

RolesHeader.propTypes = {
  className: PropTypes.string
};

export default RolesHeader;
